module.exports = __webpack_public_path__ + "img/racetrack-vaal-turf-classic.45bbf5cd.svg";